export function rightRoundedRect(
  x: number,
  y: number,
  width: number,
  height: number,
  radius: number
): string {
  const r = width < radius ? 0 : radius;
  const w = width === 0 ? 1 : width;
  return `M${x},${y}
  h${w - r}
  a${r},${r} 0 0 1 ${r},${r}
  v${height - r * 2}
  a${r},${r} 0 0 1 ${-r},${r}
  h${r - w}
  z`;
}

export function topRoundedRect(
  x: number,
  y: number,
  width: number,
  height: number,
  radius: number
): string {
  const r = height < radius ? 0 : radius;
  const h = height === 0 ? 1 : height;
  return `M${x},${y + r}
 a${r},${r} 0 0 1 ${r},${-r}
 h${width - r * 2}
 a${r},${r} 0 0 1 ${r},${r}
 v${h - r}
 h${-width}Z`;
}
